import { JobResponse, ResourceProperty } from '..'

export const enum JobTaskStatus {
  COMPLETED = 'COMPLETED',
  SUBMITTED = 'SUBMITTED',
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS'
}

export enum JobApplicationStatus {
  New = 'NEW',
  Reviewed = 'REVIEWED',
  Shortlisted = 'SHORTLISTED',
  InterviewScheduled = 'INTERVIEW_SCHEDULED',
  Offered = 'OFFERED',
  Hired = 'HIRED',
  Rejected = 'REJECTED',
  Excluded = 'EXCLUDED',
  Dropped = 'DROPPED',
  Preprocessing = 'PREPROCESSING',
  AiInterview = 'AI_INTERVIEW'
}

export interface StatusHistoryDto {
  status: JobApplicationStatus
  reason: string
  createdAt: string
}

interface DegreeField {
  _id: string
  name: string
}

interface DegreeTyoe {
  _id: string
  name: string
}

interface SchoolType {
  _id: string
  name: string
}
interface EducationRecord {
  graduationDate: string
  degreeField: DegreeField
  degreeType: DegreeTyoe
  school: SchoolType
}

interface CertificationCompany {
  name: string
  url: string
}
interface ExternalCertification {
  name: string
  issueDate: string
  credentialUrl: string
  company: CertificationCompany
}

interface Language {
  language: string
  profiency: string
}

interface Tool {
  _id: string
  name: string
  verified: boolean
}
export interface Applicant {
  _id: string
  firstName: string
  lastName: string
  email: string
  aboutMe: string
  nationality: string
  photo: string
  location: string
  educationRecords: EducationRecord[]
  externalCertifications: ExternalCertification[]
  languages: Language[]
  tools: Tool[]
}

export interface ScreeningQuestionAnswer {
  _id: string
  text: string
  answer?: string
  idealAnswer?: string
}
export interface JobApplication {
  _id?: string
  cvRating?: number
  cv?: string
  submissionRating?: number
  status?: JobApplicationStatus
  statusHistory?: StatusHistoryDto[]
  description?: string
  job?: JobResponse
  apprentice: Applicant
  appliedAt: Date | string
  files?: Partial<ResourceProperty>[]
  submittedAt: Date | string
  favorite?: boolean
  link?: string
  screeningQuestionsAnswers?: ScreeningQuestionAnswer[]
}

export interface JobApplicationResponse {
  applications: JobApplication[]
  count: number
}

export interface JobApplicationsFilter {
  favorite?: boolean
  rejected?: boolean
  dropped?: boolean
}

export interface JobApplicantDetails {
  apprentice?: Applicant
  application?: JobApplication
}
